import type { BtlApplication } from '@api/btlApplicationForm/types';
import { CaseSidebarNavItem } from './CaseSidebarNavItem';
import type { CaseSection } from '../types';
import { CaseSidebarItemId } from '../types';

interface CaseSidebarSectionGroupProps {
  section: CaseSection;
  activeItemId?: CaseSidebarItemId;
  application?: BtlApplication;
  onItemSelect?: (itemId: CaseSidebarItemId) => void;
}

export function CaseSidebarSectionGroup({
  section,
  activeItemId,
  application,
  onItemSelect,
}: CaseSidebarSectionGroupProps) {
  if (section.children.length === 0) {
    return null;
  }

  return (
    <section className='mt-4' data-testid={`case-sidebar-section-${section.title}`}>
      <h4 className='mb-0.5 px-3 text-[11px] font-medium uppercase tracking-[0.06em] text-gray-400'>{section.title}</h4>
      <div className='flex flex-col gap-1'>
        {section.children.map(item => (
          <CaseSidebarNavItem
            key={item.id}
            item={item}
            application={application}
            isActive={activeItemId === item.id}
            onClick={onItemSelect ? () => onItemSelect(item.id) : undefined}
          />
        ))}
      </div>
    </section>
  );
}
